"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.preview.title': 'Szczegóły Wiedzy',
    'knowledge.preview.edit': 'Edytuj',
    'knowledge.preview.back': 'Powrót do Listy',
    'knowledge.preview.not_found': 'Wpis wiedzy nie został znaleziony',
    'knowledge.preview.not_provided': 'Nie podano',
    'knowledge.preview.no_tags': 'Brak tagów',
    'knowledge.preview.no_file': 'Brak załączonego pliku',
    'knowledge.preview.error.load_failed': 'Nie udało się załadować wpisu wiedzy',
    'knowledge.preview.section.basic_info': 'Podstawowe Informacje',
    'knowledge.preview.section.file_info': 'Informacje o Pliku',
    'knowledge.preview.section.content': 'Zawartość',
    'knowledge.preview.section.used_by_avatars': 'Używane przez Awatary',
    'knowledge.preview.section.used_by_professions': 'Używane przez Zawody',
    'knowledge.preview.section.errors': 'Błędy',
    'knowledge.preview.content_type.text': 'Tekst',
    'knowledge.preview.content_type.file': 'Plik',
    'knowledge.preview.content_type.link': 'Link',
    'knowledge.preview.content_type.google-drive': 'Google Drive',
    'knowledge.preview.rag_status.pending': 'Oczekujący',
    'knowledge.preview.rag_status.processing': 'Przetwarzanie',
    'knowledge.preview.rag_status.completed': 'Ukończony',
    'knowledge.preview.rag_status.failed': 'Nieudany',
    'knowledge.preview.rag_status.not_indexed': 'Nie Zindeksowany',
    'knowledge.preview.active.yes': 'Tak',
    'knowledge.preview.active.no': 'Nie',
    'knowledge.preview.no_avatars_using': 'Żaden awatar obecnie nie używa tej wiedzy',
    'knowledge.preview.no_professions_using': 'Żaden zawód obecnie nie używa tej wiedzy',
};
